import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const stored = typeof localStorage !== "undefined" ? localStorage.getItem("oly_token") : null;
if (stored) {
  api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export function setToken(token) {
  if (token) {
    localStorage.setItem("oly_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("oly_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function formatApiError(detail) {
  if (detail == null) return "A apărut o eroare. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
